// Dummy-auth fixture data for the US Ops CRM.
//
// Spec: Epic FE-US-INT-01 §6 Phase 0 — single fixture organization
// "Hammond & Co LLC" (tenant id `00000000-0000-4000-8000-000000000001`) with four ops users:
// admin / sales / ops / viewer.
//
// THIS IS DEV-ONLY DATA. It is consumed exclusively by the DummyAuthProvider
// which itself is guarded by the `devMode` env flag. The bundle-grep CI
// gate in Phase 6 will reject any production build that contains these
// email addresses.

import type { DummyOrganization, DummyUser } from '@fluxora/auth';

export const DUMMY_ORG: DummyOrganization = {
  id: '00000000-0000-4000-8000-000000000001',
  name: 'Hammond & Co LLC',
  countryCode: 'US',
};

export const DUMMY_USERS: readonly DummyUser[] = [
  {
    id: '00000000-0000-4000-8000-100000000001',
    email: 'admin@hammond.example',
    displayName: 'Alex Mitchell',
    role: 'admin',
  },
  {
    id: '00000000-0000-4000-8000-100000000002',
    email: 'sales@hammond.example',
    displayName: 'Jordan Reyes',
    role: 'sales',
  },
  {
    id: '00000000-0000-4000-8000-100000000003',
    email: 'ops@hammond.example',
    displayName: 'Sam Patel',
    role: 'ops',
  },
  {
    id: '00000000-0000-4000-8000-100000000004',
    email: 'viewer@hammond.example',
    displayName: 'Riley Chen',
    role: 'viewer',
  },
  {
    id: '00000000-0000-4000-8000-100000000005',
    email: 'jatin.verma@centralogic.net',
    displayName: 'Jatin Verma',
    role: 'admin',
  },
] as const;
